import React from "react";

const upcomingeventHeading = ({ heading, className = '' }) => {
    return (
        <div>
            <h2 className={`text-29xl  text-white font-normal ${className}`}>{heading}</h2>

        </div>
    );
};

export default upcomingeventHeading;